import React, { PureComponent } from 'react';

export default function withSlide(Comp) {
  return class SlideComponent extends PureComponent {
    render() {
      return (
        <div className="analysis-slide">
          <Comp {...this.props} />
        </div>
      );
    }
  }
}
